<div class="gwc-payment-module">
	@switch (step()) {
		@case ('summary') {
			@if (payload()) {
				<div class="gwc-card gwc-payment-module__summary">
					<h2>Order Summary</h2>

					@for (addon of payload()!.addons; track addon.uuid) {
						<h3>
							{{ addon.name }}
						</h3>
						<section class="gwc-payment-module__item">
							<div>
								{{ addon.service }}
							</div>
							<div>
								{{ addon.expected_price | currency }}
							</div>
						</section>
					}
					<section class="gwc-payment-module__total">
						<div class="gwc-payment-module__total-label">
							Total
						</div>
						<div>
							{{ total() | currency }}
						</div>
					</section>
				</div>
			}
		
			<section class="gwc-card gwc-payment-module__payment-information">
				<h2>Payment Information</h2>
				<p>Select a payment method to continue.</p>

				<gwc-payment-profiles (onProfileSelected)="onProfileSelected($event)"
					[ccForm]="ccForm">
				</gwc-payment-profiles>
			</section>

		
			<div class="gwc-payment-module__terms">
				<mat-checkbox color="primary" [formControl]="termsAccepted">
					By authorizing payment for <strong>{{ total() | currency }}</strong>, I am acknowledging that I have reviewed and agree with the Terms of Use and Privacy Policy.
				</mat-checkbox>
			</div>
		
			<div>
				<gwc-button class="gwc-payment-module__submit"
					[rounded]="true"
					color="primary"
					[disabled]="processingPayment()"
					(click)="placeOrder()">
					Confirm Payment
				</gwc-button>
			</div>
			@if (paymentError()) {
				<div class="gwc-payment-module__error">
					{{ paymentError() }}
				</div>
			}
		}
		@case ('confirmation') {
			<div class="gwc-card gwc-payment-module__summary">
				<h2>Payment Details</h2>
				@for (addon of payload()!.addons; track addon.uuid) {
					<h3>
						{{ addon.name }}
					</h3>
					<section class="gwc-payment-module__item">
						<div>
							{{ addon.service }}
						</div>
						<div>
							{{ addon.expected_price | currency }}
						</div>
					</section>
				}
				<section class="gwc-payment-module__total">
					<div class="gwc-payment-module__total-label">
						Total
					</div>
					<div>
						{{ total() | currency }}
					</div>
				</section>
			</div>
		}
	}
</div>
